module.exports = __webpack_public_path__ + "static/media/blik.f3872fac.svg";